import { UserRight } from '../../core/models/User';
import { WhoAreYou } from '../core/WhoAreYou';
import { ValentinesDayBody } from './ValentinesDayBody';


export default function ValentinesDayPage() {
    return (
        <WhoAreYou requiredUserRight={UserRight.zahra}>
            <ValentinesDayBody />
        </WhoAreYou>
    )
}